import { Injectable, inject } from '@angular/core';
import { NetzbetreiberDetailComponent } from './netzbetreiber-detail/netzbetreiber-detail.component';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root',
})
export class NetzbetreiberDialogService {
    private dialog = inject(MatDialog);


    private netzbetreiberChanged$ = new BehaviorSubject<boolean>(true);

    public observeNetzbetreiberChanged(): Observable<boolean> {
        return this.netzbetreiberChanged$.asObservable();
    }

    public openDetail(data: {orgId?: string, createNew?: boolean}) {
        const dialogRef = this.dialog.open(NetzbetreiberDetailComponent, {
            disableClose: true,
            panelClass: 'ufla-detail-dialog-container',
            data: { orgId: data.orgId, createNew: data.createNew },
        });

        firstValueFrom(dialogRef.afterClosed()).then(() => this.netzbetreiberChanged$.next(true));
    }
}
